import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import useI18n from '~Translations';
import Icon from '~ComponentsImproved/Icon';
import { useButton } from '~Hooks';
import SwapIcon from '~/Assets/icons/swap.svg';
import { SERVICE_TYPE } from '../../../../../../__queries__';

const Wrapper = styled.div<{
  isPhone?: boolean;
  isTakeAway?: boolean;
}>`
  position: fixed;
  left: 50px;
  top: ${({ isPhone }) => (isPhone ? '52px' : '12px')};
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.24px;
    color: ${({ isTakeAway }) =>
      isTakeAway ? 'var(--colorUIYellow)' : 'var(--colorBlueGray200)'};
  }
`;

const ServiceTypeButton = styled.div<{
  touching?: boolean;
  isTakeAway?: boolean;
}>`
  text-align: center;
  border-radius: 4px;
  color: var(--colorWhite);
  background-color: var(--colorBlueGray1300);
  border: 1px solid;
  border-color: var(--colorBlueGray300);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2), 0 0 12px rgba(0, 0, 0, 0.1);
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ touching }) => (touching ? 'scale(0.96)' : '1')};
  transition: transform 0.1s ease-out, opacity 0.1s ease-in-out;
`;

interface Props {
  currentServiceType: SERVICE_TYPE;
  updateServiceType: (type: SERVICE_TYPE) => void;
  isPhone?: boolean;
}

const ToggleServiceType: FC<Props> = ({ currentServiceType, updateServiceType, isPhone }) => {
  const { i18n } = useI18n();

  const serviceTypeButton = useButton({
    onClick: () => {
      const newServiceType =
        currentServiceType === SERVICE_TYPE.EAT_HERE
          ? SERVICE_TYPE.TAKE_AWAY
          : SERVICE_TYPE.EAT_HERE;

      updateServiceType(newServiceType);
    },
  });

  return (
    <Wrapper isPhone={isPhone} isTakeAway={currentServiceType === SERVICE_TYPE.TAKE_AWAY}>
      <ServiceTypeButton
        {...serviceTypeButton}
        isTakeAway={currentServiceType === SERVICE_TYPE.TAKE_AWAY}>
        <Icon src={SwapIcon} color="var(--colorWhite)" />
      </ServiceTypeButton>
      <span {...serviceTypeButton}>
        {currentServiceType === SERVICE_TYPE.EAT_HERE ? i18n('POS.Eathere') : i18n('POS.TakeAway')}
      </span>
    </Wrapper>
  );
};

export default memo(ToggleServiceType, (prevProps, nextProps) => {
  return (
    prevProps.currentServiceType === nextProps.currentServiceType &&
    prevProps.isPhone === nextProps.isPhone
  );
});
